import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["globalPid", "langLocale", "descriptionHeading", "description", "techSpec", "manufacturingCountriesOfOrigin", "fit", "colors", "bestFor", "athletes", "widths"],
  _excluded2 = ["snapshotId", "modificationDate", "status", "styleCode", "colorCode", "catalogId", "productGroupId", "channels", "consumerChannels", "legacyCatalogIds", "genders", "sizeConverterId", "sizeGuideId", "sportTags", "classificationConcepts", "taxonomyAttributes", "commerceCountryInclusions", "commerceCountryExclusions", "abTestValues", "productRollup", "mainColor", "isAttributionApproved", "commercePublishDate", "commerceStartDate", "limitRetailExperience", "resourceType", "links", "id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DOTCOM_CHANNEL_ID, SNRKS_WEB_CHANNEL_ID } from "../../../constants/channel-ids";

// Using both dotcom and snkrs web channels is required to support our downstream content authoring platform Artemis.
// This will allow all dotcom products to function as expected. This supports product adds from snkrs web as well as dotcom.
// Product feeds supports multiple channels, so we will utilize this strategy until cart views is implemented.
// Only utilize multiple channel ids to support geos that use Artemis, otherwise just use the dotcom id

export var getChannelId = function getChannelId(country) {
  if (country === 'kr') {
    return "".concat(DOTCOM_CHANNEL_ID, ",").concat(SNRKS_WEB_CHANNEL_ID);
  }
  return DOTCOM_CHANNEL_ID;
};
export var transformsFeedData = function transformsFeedData(data) {
  var _node$publishedConten2, _node$publishedConten3, _data$errors;
  var node = data === null || data === void 0 ? void 0 : data.objects.filter(function (node) {
    var _node$publishedConten;
    return (_node$publishedConten = node.publishedContent) === null || _node$publishedConten === void 0 ? void 0 : _node$publishedConten.properties.productCard;
  })[0];
  var _ref = (node === null || node === void 0 ? void 0 : node.productInfo[0]) || {},
    productContent = _ref.productContent,
    merchProduct = _ref.merchProduct;
  var productCardProps = (node === null || node === void 0 || (_node$publishedConten2 = node.publishedContent) === null || _node$publishedConten2 === void 0 || (_node$publishedConten2 = _node$publishedConten2.properties) === null || _node$publishedConten2 === void 0 ? void 0 : _node$publishedConten2.productCard.properties) || {};
  var imageUrl = productCardProps.squarishURL || '';
  var portraitImageUrl = productCardProps.portraitURL || '';
  var altText = productCardProps.altText || '';

  // product nodes contain additional images for the product
  var productNodes = (_node$publishedConten3 = node.publishedContent) === null || _node$publishedConten3 === void 0 || (_node$publishedConten3 = _node$publishedConten3.nodes[0]) === null || _node$publishedConten3 === void 0 ? void 0 : _node$publishedConten3.nodes;
  var _ref2 = productContent || {},
    globalPid = _ref2.globalPid,
    langLocale = _ref2.langLocale,
    descriptionHeading = _ref2.descriptionHeading,
    description = _ref2.description,
    techSpec = _ref2.techSpec,
    manufacturingCountriesOfOrigin = _ref2.manufacturingCountriesOfOrigin,
    fit = _ref2.fit,
    colors = _ref2.colors,
    bestFor = _ref2.bestFor,
    athletes = _ref2.athletes,
    widths = _ref2.widths,
    restProductContent = _objectWithoutProperties(_ref2, _excluded);
  var _ref3 = merchProduct || {},
    snapshotId = _ref3.snapshotId,
    modificationDate = _ref3.modificationDate,
    status = _ref3.status,
    styleCode = _ref3.styleCode,
    colorCode = _ref3.colorCode,
    catalogId = _ref3.catalogId,
    productGroupId = _ref3.productGroupId,
    channels = _ref3.channels,
    consumerChannels = _ref3.consumerChannels,
    legacyCatalogIds = _ref3.legacyCatalogIds,
    genders = _ref3.genders,
    sizeConverterId = _ref3.sizeConverterId,
    sizeGuideId = _ref3.sizeGuideId,
    sportTags = _ref3.sportTags,
    classificationConcepts = _ref3.classificationConcepts,
    taxonomyAttributes = _ref3.taxonomyAttributes,
    commerceCountryInclusions = _ref3.commerceCountryInclusions,
    commerceCountryExclusions = _ref3.commerceCountryExclusions,
    abTestValues = _ref3.abTestValues,
    productRollup = _ref3.productRollup,
    mainColor = _ref3.mainColor,
    isAttributionApproved = _ref3.isAttributionApproved,
    commercePublishDate = _ref3.commercePublishDate,
    commerceStartDate = _ref3.commerceStartDate,
    limitRetailExperience = _ref3.limitRetailExperience,
    resourceType = _ref3.resourceType,
    links = _ref3.links,
    id = _ref3.id,
    restMerchProduct = _objectWithoutProperties(_ref3, _excluded2);
  // format data as presented from previous GrAND response
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    id: id
  }, restMerchProduct), merchProduct !== null && merchProduct !== void 0 && merchProduct.customization ? {
    customization: merchProduct.customization
  } : {}), (_data$errors = data.errors) !== null && _data$errors !== void 0 && _data$errors.length ? data.errors : {}), {}, {
    content: _objectSpread(_objectSpread({}, restProductContent), {}, {
      productId: id,
      imageUrl: imageUrl,
      portraitImageUrl: portraitImageUrl,
      altText: altText,
      productNodes: productNodes
    })
  });
};